import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(1 1)">
      <polygon className="euiIcon__fillSecondary" points="2 21 5 21 5 23 0 23 0 0 23 0 23 5 21 5 21 2 2 2"/>
      <path
        d="M14.2281725,28 C15.7203327,26.3216689 15.5808623,25.1411793 14.2370245,22.3460401 C14.1884818,22.2450794 14.1884818,22.2450794 14.1396582,22.1433287 C12.7709779,19.2878552 12.5143717,17.6515213 13.814501,15.5606228 C16.610978,11.0632625 23.3288096,12.9186961 28,17.8783204 L28,9 L9,9 L9,28 L14.2281725,28 Z M16.6988988,28 L28,28 L28,21.0165966 C24.119707,15.611358 17.6237116,13.2221101 15.5129327,16.6167146 C14.6822082,17.9527052 14.844284,18.986235 15.9431838,21.2788661 C15.9911093,21.3787453 15.9911093,21.3787453 16.0395241,21.4794403 C17.3921778,24.2929164 17.7711228,26.1096765 16.6988988,28 Z M30,7 L30,30 L7,30 L7,7 L30,7 Z"/>
    </g>
  </svg>
)
